import '@/utils/jsbridge-client';
import { createRoot } from 'react-dom/client';
import { initBrowserI18n } from '@/utils/i18n';
import App from './app';
import { registerPwa } from './lib/pwa';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

initBrowserI18n();

const root = createRoot(container);
root.render(<App />);

registerPwa();
